import axios from "axios";

export function fetchFilters(params = {}) {
    return axios.get('/clsystem/api/v1/filters', {params: params})
}
